import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH_TEMPLATE =
  '/workflows/user-workflows/{userWorkflowId}/questionnaires/{questionnaireId}/generated-pdfs/{pdfTemplateId}';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const generateFormPDF = async ({ userWorkflowId, questionnaireId, pdfTemplateId }: Input): Promise<Output> => {
  const response = await noodleApiClient.post(
    `/workflows/user-workflows/${userWorkflowId}/questionnaires/${questionnaireId}/generated-pdfs/${pdfTemplateId}`,
  );
  return response.data;
};

export default generateFormPDF;
